import { useState } from 'react';
import { AppStatus, Loading, PrimaryButton, getStatusText } from '../atoms';

import { DisplayTable, DisplayTableHead, DisplayTableRow } from '../molecules';
import type { TApplications } from '../types';
import React from 'react';

type TApplicationsList = {
  applications: TApplications;
  isLoading?: boolean;
  refresh?: () => void;
};

const ApplicationsList = ({
  applications,
  isLoading,
  refresh
}: TApplicationsList) => {
  const [hideRequestTerms, setHideRequestTerms] = useState(false); // hide button after successful request and modal closed

  const refreshPage = () => {
    setHideRequestTerms(true);
    refresh?.();
  };

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && applications?.length === 0 && (
        <DisplayTable colWidths={['auto']} colWidthsMd={['auto']}>
          <DisplayTableRow
            type="div"
            cells={[
              {
                contentType: 'error',
                content: 'No applications found'
              }
            ]}
          />
        </DisplayTable>
      )}
      {!isLoading && !!applications?.length && (
        <DisplayTable
          colWidths={[
            '140px',
            '164px',
            '164px',
            '140px',
            '178px',
            '120px',
            'auto'
          ]}
          colWidthsMd={[
            '6.25rem',
            '11rem',
            '11rem',
            '7rem',
            '7rem',
            '5rem',
            'auto'
          ]}
          hasButton={true}
        >
          <DisplayTableHead
            cols={[
              '',
              'Borrower',
              'Student',
              'Plan Amount',
              'Status',
              'Product',
              'Course Name',
              ''
            ]}
          />
          {applications.map((application) => {
            const {
              applicationStep,
              applicationSubStep,
              borrower,
              creationDate,
              email,
              loanApplicationId,
              mambuAccountId,
              phoneNumber,
              planAmount,
              pol,
              polSubCategory,
              productType,
              salesforceAppNumber,
              student
            } = application;

            let isDataIncomplete = false;
            if (
              borrower === 'NO_DATA' ||
              student === 'NO_DATA' ||
              planAmount === 'NO_DATA' ||
              applicationStep === 'NO_DATA' ||
              pol === 'NO_DATA' ||
              phoneNumber === 'NO_DATA' ||
              email === 'NO_DATA'
            ) {
              isDataIncomplete = true;
            }
            const courseName =
              polSubCategory && polSubCategory !== 'NO_DATA'
                ? polSubCategory
                : pol;
            return (
              <DisplayTableRow
                key={loanApplicationId}
                type="modal"
                cells={[
                  {
                    contentType: 'idAndDate',
                    content: [
                      salesforceAppNumber || loanApplicationId,
                      creationDate,
                      isDataIncomplete
                    ]
                  },
                  {
                    contentType: 'text',
                    content: borrower
                  },
                  {
                    contentType: 'text',
                    content: student
                  },
                  {
                    contentType: 'currency',
                    content: planAmount
                  },
                  {
                    contentType: 'text',
                    content: (
                      <AppStatus
                        statusText={
                          getStatusText(applicationStep, applicationSubStep) ||
                          undefined
                        }
                        small={true}
                      />
                    )
                  },
                  {
                    contentType: 'text',
                    content: productType
                  },
                  {
                    contentType: 'text',
                    content: courseName
                  }
                ]}
                modalType="application"
                modalTitle="Application"
                modalAppContent={application}
                refreshPage={refreshPage}
                button={
                  applicationStep === 'Pending Approval' &&
                  applicationSubStep === 'PA_REFER' &&
                  mambuAccountId &&
                  !hideRequestTerms ? (
                    <PrimaryButton>Request Different Term</PrimaryButton>
                  ) : undefined
                }
                buttonModalType={
                  applicationStep === 'Pending Approval' &&
                  applicationSubStep === 'PA_REFER' &&
                  mambuAccountId &&
                  !hideRequestTerms
                    ? 'requestDifferentTerm'
                    : undefined
                }
              />
            );
          })}
        </DisplayTable>
      )}
    </>
  );
};

export { ApplicationsList };
